import React, { FC } from 'react';
import PageWrapper from '../PageWrapper';
import Navigation from '../Navigation';
import { ICrumb } from '../../types';

interface INavigationPage {
  allRoutes: ICrumb[];
  givenRoute: ICrumb;
  routePath: string;
  routeParams?: Record<string, any>;
  additional?: JSX.Element;
  isRouter?: boolean;
  homeUrl?: string
}

const NavigationPage: FC<INavigationPage> = ({
                                               allRoutes,
                                               givenRoute,
                                               routePath,
                                               routeParams,
                                               additional,
                                               isRouter,
                                               homeUrl
                                             }) => {
  const { Component, customCrumbsCallback } = givenRoute;

  const mapRoutesToString = (path: string, rest:  Omit<ICrumb, "path">) => ({
    path:
      routeParams && Object.keys(routeParams).length
        ? Object.keys(routeParams).reduce(
          (path, param) => path.replace(`:${param}`, `${routeParams[param]}`),
          path
        )
        : path,
    ...rest,
  })

  const customCrumbs = function () {
    if (customCrumbsCallback?.(givenRoute)) {
      return customCrumbsCallback(givenRoute).map(({ path, ...rest }) => mapRoutesToString(path, rest));
    }
    return false;
  }();

  const crumbs = allRoutes
    .filter(({ path }) => routePath.includes(path))
    .map(({ path, ...rest }) => mapRoutesToString(path, rest));

  return (
    <PageWrapper
      bgType={givenRoute.isBackgroundImage ? 'image' : 'color'}
      bgImageUrl={givenRoute.backgroundImage}
    >
      {givenRoute.isNavigation && (
        <Navigation
          additionalCrumbs={givenRoute.additionalCrumbs}
          baseUrl=''
          crumbs={customCrumbs ? customCrumbs : crumbs}
          homeUrl={homeUrl ? homeUrl : '/'}
          isRouter={isRouter}
        />
      )}
      <Component {...givenRoute.data} />
      {additional}
    </PageWrapper>
  );
};

export default NavigationPage;
